// extracted by mini-css-extract-plugin
export default {"container":"NftOfferForActivity_container__-hxQb"};